import React, { useState } from "react";
import { Routes, Route, NavLink } from "react-router-dom";
import Layout from "../components/Layout";
import PermissionMatrix from "../components/PermissionMatrix";
import TransferRulesManager from "../components/TransferRulesManager";
import AdminManagement from "./AdminManagement";
import UserManagement from "./UserManagement";
import Dashboard from "./Dashboard";
import RolesManagement from "./RolesManagement";
import PermissionsManagement from "./PermissionsManagement";
import CuttingManagement from "./CuttingManagement";
import CuttingStatusUpdate from "./CuttingStatusUpdate";
import TrimmingManagement from "./TrimmingManagement";
import TrimmingStatusUpdate from "./TrimmingStatusUpdate";
import NocStatusUpdate from "./NocStatusUpdate";
import DivisionManagement from "./DivisionManagement";
import SidebarMenuManagement from "./SidebarMenuManagement";
import AnnouncementManagement from "./AnnouncementManagement";
import GardenManagement from "./GardenManagement";
import SliderManagement from "./SliderManagement";
import NmmcCardManagement from "./NmmcCardManagement";
import CivicServicesManagement from "./CivicServicesManagement";
import NewsManagement from "./NewsManagement";
import TicketList from "./TicketList";
import TicketDetail from "./TicketDetail";
import CreateTicket from "./CreateTicket";
import { useAuth } from "../context/AuthContext";


const SuperadminDashboard = () => {
  const { hasPermission } = useAuth();
  const [citizenPanelOpen, setCitizenPanelOpen] = useState(false);
  const [adminPanelOpen, setAdminPanelOpen] = useState(false);

  return (
    <Layout title="Superadmin Dashboard">
      <div className="flex">
        <aside className="w-64 bg-white shadow-md p-4 min-h-screen">
          <nav className="space-y-2">
            <h2 className="text-blue-700 font-bold text-2xl px-8 py-3">
              Control Panel
            </h2>

            <NavLink
              to="dashboard"
              className={({ isActive }) =>
                `block px-4 py-2 rounded-md ${
                  isActive
                    ? "bg-blue-700 text-blue-100"
                    : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              Dashboard
            </NavLink>

            {/* CITIZEN PANEL Section */}
             <div className="mb-4">
              <button
                onClick={() => setCitizenPanelOpen(!citizenPanelOpen)}
                className="w-full text-left text-gray-600 font-semibold text-sm uppercase px-4 py-2 border-b border-gray-200 hover:bg-gray-50 cursor-pointer flex items-center justify-between"
              >
                <span>CITIZEN PANEL</span>
                <span className="text-xs">
                  {citizenPanelOpen ? "▼" : "▶"}
                </span>
              </button>
              {citizenPanelOpen && (
                <div className="mt-2 space-y-1">
                <NavLink
                  to="slider"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  HOME IMG
                </NavLink>
                <NavLink
                  to="nmmc-card"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  NMMC card
                </NavLink>
                <NavLink
                  to="civic-services"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Civic Services
                </NavLink>
                <NavLink
                  to="sidebar-menu"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Civic Dashboard
                </NavLink>
                <NavLink
                  to="gardens"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Gardens
                </NavLink>
                </div>
              )}
            </div>

            {/* ADMIN PANEL Section */}
            <div className="mb-4">
              <button
                onClick={() => setAdminPanelOpen(!adminPanelOpen)}
                className="w-full text-left text-gray-600 font-semibold text-sm uppercase px-4 py-2 border-b border-gray-200 hover:bg-gray-50 cursor-pointer flex items-center justify-between"
              >
                <span>ADMIN PANEL</span>
                <span className="text-xs">
                  {adminPanelOpen ? "▼" : "▶"}
                </span>
              </button>
              {adminPanelOpen && (
                <div className="mt-2 space-y-1">
                <NavLink
                  to="permissions-list"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Permissions Management
                </NavLink>
                <NavLink
              to="gardens"
              className={({ isActive }) =>
                `block px-4 py-2 rounded-md ml-2 ${
                  isActive
                    ? "bg-blue-700 text-blue-100"
                    : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              Garden Management 
            </NavLink>
                <NavLink
                  to="roles"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Roles Management
                </NavLink>
                <NavLink
                  to="permissions"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Permission Matrix
                </NavLink>
                <NavLink
                  to="transfer-rules"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Transfer Rules
                </NavLink>
                <NavLink
                  to="divisions"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Division Management
                </NavLink>
                <NavLink
                  to="admins"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Admin Management
                </NavLink>
                <NavLink
                  to="users"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  User Management
                </NavLink>
                <NavLink
                  to="cutting"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Cutting Applications
                </NavLink>
                <NavLink
                  to="cutting-status-update"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Cutting Status Update
                </NavLink>
                <NavLink
                  to="trimming"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Trimming Applications
                </NavLink>
                <NavLink
                  to="trimming-status-update"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Trimming Status Update
                </NavLink>
                <NavLink
                  to="noc-status-update"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  NOC Status Update
                </NavLink>
                <NavLink
                  to="sidebar-menu"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Sidebar Menu Management
                </NavLink>
                <NavLink
                  to="announcements"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Announcement Management
                </NavLink>
                <NavLink
                  to="civic-services"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Civic Services Management
                </NavLink>
                <NavLink
                  to="slider"
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded-md ml-2 ${
                      isActive
                        ? "bg-blue-700 text-blue-100"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  Slider Management
                </NavLink>

                <NavLink
              to="tickets"
              className={({ isActive }) =>
                `block px-4 py-2 rounded-md ${
                  isActive
                    ? "bg-blue-700 text-blue-100"
                    : "text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              Support Tickets
            </NavLink>
                </div>

              )}
            </div>
          </nav>
        </aside>

        <div className="flex-1 ml-6 p-4">
          <Routes>
            <Route path="roles" element={<RolesManagement />} />
            <Route
              path="permissions-list"
              element={<PermissionsManagement />}
            />
            <Route path="permissions" element={<PermissionMatrix />} />
            <Route path="transfer-rules" element={<TransferRulesManager />} />
            <Route path="divisions" element={<DivisionManagement />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="admins" element={<AdminManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="cutting" element={<CuttingManagement />} />
            <Route path="cutting-status-update" element={<CuttingStatusUpdate />} />
            <Route path="trimming" element={<TrimmingManagement />} />
            <Route path="trimming-status-update" element={<TrimmingStatusUpdate />} />
            <Route path="noc-status-update" element={<NocStatusUpdate />} />
            <Route path="sidebar-menu" element={<SidebarMenuManagement />} />
            <Route path="announcements" element={<AnnouncementManagement />} />
            <Route path="civic-services" element={<CivicServicesManagement />} />
            <Route path="gardens" element={<GardenManagement />} />
            <Route path="slider" element={<SliderManagement />} />
            <Route path="nmmc-card" element={<NmmcCardManagement />} />
            <Route path="news-management" element={<NewsManagement />} />
            <Route path="tickets" element={<TicketList />} />
            <Route path="tickets/create" element={<CreateTicket />} />
            <Route path="tickets/:id" element={<TicketDetail />} />
            
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </div>
      </div>
    </Layout>
  );
};

export default SuperadminDashboard;
